import { ClientEnv } from '@/env';

export const getNumberIdsFromString = (idString: string | undefined): number[] => {
  if (!idString) return [];

  const ids: number[] = [];
  for (const id of idString.split(',')) {
    const parsedId = parseInt(id.trim(), 10);
    if (!isNaN(parsedId)) {
      ids.push(parsedId);
    }
  }

  return ids;
};

export const isFormDynamicsLocationEnabled = (env: ClientEnv, location: string): boolean => {
  const locationMap: Record<string, boolean> = {
    'Phoenix, AZ': env.DYNAMICS_LOCATION_PHOENIX_ENABLED,
    'Mesa, AZ': env.DYNAMICS_LOCATION_MESA_ENABLED,
    'Tucson, AZ': env.DYNAMICS_LOCATION_TUCSON_ENABLED,
    'Fremont, CA': env.DYNAMICS_LOCATION_FREMONT_ENABLED,
    'West Sacramento, CA': env.DYNAMICS_LOCATION_WEST_SACRAMENTO_ENABLED,
    'San Diego, CA': env.DYNAMICS_LOCATION_SAN_DIEGO_ENABLED,
    'Orlando (Sanford), FL': env.DYNAMICS_LOCATION_ORLANDO_SANFORD_ENABLED,
    'Port St. Lucie, FL': env.DYNAMICS_LOCATION_PORT_ST_LUCIE_ENABLED,
    'Ft. Myers, FL': env.DYNAMICS_LOCATION_FT_MYERS_ENABLED,
    'Davie, FL': env.DYNAMICS_LOCATION_DAVIE_ENABLED,
    'Albuquerque, NM': env.DYNAMICS_LOCATION_ALBUQUERQUE_ENABLED,
  };

  return locationMap[location] || false;
};
